import { render, staticRenderFns } from "./TransporterContractAddDialog.vue?vue&type=template&id=5dd57fc3"
import script from "./TransporterContractAddDialog.vue?vue&type=script&lang=js"
export * from "./TransporterContractAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports